import { HandlingUnitType } from "@redotech/redo-fulfillment-carrier-common/freight";
import { FreightHandlingUnitRowSchema } from "@redotech/redo-fulfillment-common/freight/freight-handling-unit";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createFreightHandlingUnit = {
  name: "createFreightHandlingUnit" as const,
  input: z.object({
    name: z.string(),
    type: createEnum(HandlingUnitType, { enumName: "HandlingUnitType" }),
    length: z.number(),
    width: z.number(),
    height: z.number(),
    isDefault: z.boolean().optional(),
  }),
  output: FreightHandlingUnitRowSchema,
};
